// Admin Set Data Source

<template>
	<div class="ds-main">

		<div class="header wi8_font">
			Choose Data Source<br/>(current: {{ sourceName }})
		</div>

		<div v-for="(item, keyName) in CfgApi.sources" :key="'cfgapi'+keyName" :class="(keyName==sourceName)? 'item active': 'item'" >
			

			<div @click="setDS(keyName)" class="btn">
				{{ keyName }}
				<div class="flag-box">
					<UniIcon v-if="keyName==sourceName"
						ico="check"
						fit="1"
						pad="0"
						color="#369"
					/>
				</div>
			</div>
			
			<div class="detail-box">
				<div class="detail-line" v-for="(addr, name) in item" :key="'cfgapi'+name" >
					{{ name }} : {{ addr }}
				</div>
			</div>
		
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState, mapGetters } from "vuex";
import CfgApi from "@/assets/cfg/CfgApi.json";
export default {
	data() {
		return {
			CfgApi: CfgApi,
		}
	},
	computed: {
		...mapState('api',['sourceName']),
	},
	methods: {
		setDS(newName) {
			m("set DS", newName);
			let data = {
				name: newName,
			}
			this.$store.dispatch("api/setDataSource", data);
		},
	},
}
</script>

<style scoped>
.ds-main {
	height: 100%;
	overflow-x:hidden;
	overflow-y: auto;
	background-color: #F9FFF9;
	padding: 5px;
	border: solid 0px #C30;
}

.header {
	height: 50px;
	overflow: hidden;
	text-align: center;
	color: #369;
	border: solid 0px #369;
}

.item {
	padding: 5px 0px 0px;
	background-color: #DED;
	border: solid 0px #000;
	border-bottom: solid 1px #999;
}

.active {
	background-color: #FFF;
}

.btn {
	display: inline-block;
	width: 60px;
	height: 70px;
	overflow: hidden;
	cursor: pointer;
	padding: 5px 0px 0px 0px;
	text-align: center;
	font-size: 15px;
	color: #369;
	background-color: #FFF;
	border-radius: 6px;
	border: solid 1px #69C;
	border-right: solid 2px #999;
	border-bottom: solid 2px #999;
}

.flag-box {
	display: inline-block;
	width: 40px;
	height: 40px;
	overflow: hidden;
	vertical-align: top;
	padding: 5px;
	border: solid 0px #C30;
}

.detail-box {
	display: inline-block;
	width: calc(100% - 70px);
	overflow: hidden;
	vertical-align: top;
	padding: 0px 0px 0px 5px;
	border: solid 0px #090;
}

.detail-line {
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	border: solid 0px #CCC;
	border-bottom: solid 1px #999;
}



</style>
